import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';

import { COMPARE_CHART } from 'constants/charts';
import ChartReport from 'components/charts/Chart';
import CategoryApi from '../../apis/Category';
import BusinessApi from '../../apis/Business';
import { getBusinessId } from '../../constants/localStorageManager';

const CategoryComparisionReport = ({
  questionId,
  startDate,
  endDate,
  match,
}) => {
  const { id } = match.params;
  const businessId = getBusinessId() || id;
  const [categories, setCategories] = useState([]);
  const [filterSeperatorIndex, setFilterSeperatorIndex] = useState(0);

  const fetchCategories = async () => {
    try {
      const { data } = await CategoryApi.getAll();
      const { data: businessData } = await BusinessApi.getDetails(businessId);
      const businessCategories = businessData.categories;
      const otherCategories = data.filter(({ id }) => {
        const foundCategory = businessCategories.find(cat => cat.id === id);
        return !foundCategory;
      });
      const categories = [...businessCategories, ...otherCategories];
      setCategories(categories);
      setFilterSeperatorIndex(businessCategories.length - 1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div className="p-3 d-flex" style={{ overflowX: 'scroll' }}>
      <ChartReport
        key={categories.length}
        titleText="How did each participants respond on category?"
        subtitleText="Compared to average participants"
        chartType="column"
        category="category"
        dataType="comparison"
        filterType="category"
        axisTitle="Percentage of respondants"
        percentage
        colors={COMPARE_CHART}
        filters={categories}
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
        filterSeperatorIndex={filterSeperatorIndex}
        containerClassName="w-100"
      />
    </div>
  );
};

export default withRouter(CategoryComparisionReport);



// WEBPACK FOOTER //
// ./src/components/advancedReport/categoryComparision.js